import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';
import { CalculoIndicador, ExcecaoIndicadorAnaliseDesconto, IndicadorAnaliseDesconto } from "../models/indicador-analise-desconto";

@Injectable({
  providedIn: 'root'
})
export class IndicadorAnaliseDescontoService {

  constructor(private http: HttpClient) { }

  consultarComPaginacao(descri: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);

    if (descri.length > 0) {
      parametros = parametros.set('descri', descri);
    }

    return this.http.get<any>(globals.apiUrl + '/api/IndicadorAnaliseDesconto/ListaPag',
      {
        params: parametros
      });
  }

  consultarLista(idProduto?) {

    let parametros = new HttpParams();

    if (idProduto !== null && idProduto !== undefined) {
      parametros = parametros.set('idProduto', idProduto);
    }

    return this.http.get<any>(globals.apiUrl + '/api/IndicadorAnaliseDesconto/Lista', { params: parametros });
  }

  consultarPorId(id: number) {
    return this.http.get<any>(globals.apiUrl + '/api/IndicadorAnaliseDesconto/Buscar',
      { params: new HttpParams().set('id', id.toString()) });
  }

  buscarExcecoes() {
    return this.http.get<any>(globals.apiUrl + '/api/IndicadorAnaliseDesconto/Excecoes');
  }

  salvar(indicador: IndicadorAnaliseDesconto) {
    return this.http.post(globals.apiUrl + '/api/IndicadorAnaliseDesconto/Salvar', indicador);
  }

  salvarExcecao(excecao: ExcecaoIndicadorAnaliseDesconto) {
    return this.http.post(globals.apiUrl + '/api/IndicadorAnaliseDesconto/SalvarExcecao', excecao);
  }

  excluirExcecao(idProduto: number) {
    return this.http.delete(globals.apiUrl + '/api/IndicadorAnaliseDesconto/ExcluirExcecao',
      { params: new HttpParams().set('idProduto', idProduto.toString()) });
  }

  excluir(id: number) {
    return this.http.delete(globals.apiUrl + '/api/IndicadorAnaliseDesconto/Excluir',
      { params: new HttpParams().set('id', id.toString()) });
  }

  calculoIndicador(calculo: CalculoIndicador) {
    return this.http.post<any>(globals.apiUrl + '/api/IndicadorAnaliseDesconto/CalculoIndicador', calculo);
  }
}
